module.exports = __webpack_public_path__ + "media/images/icons/outlined/hdd-59cbc8e51a7367456505699366bc3300.svg";